import React, { forwardRef } from 'react';
import styles from './Toggle.module.scss';

export interface ToggleProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    /** Whether the toggle is checked */
    checked?: boolean;
    /** Callback when toggle state changes */
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    /** Whether the toggle is disabled */
    disabled?: boolean;
    /** Custom className for the container */
    className?: string;
}

export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
    ({ checked, onChange, disabled = false, className = '', ...props }, ref) => {
        const containerClasses = [styles.toggleContainer, className].filter(Boolean).join(' ');

        return (
            <label className={containerClasses}>
                <input
                    ref={ref}
                    type='checkbox'
                    className={styles.toggleInput}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    {...props}
                />
                <span className={`${styles.toggleSlider} ${disabled ? styles.disabled : ''}`}></span>
            </label>
        );
    }
);

Toggle.displayName = 'Toggle';
